<template>
    <div v-if="current">
  
      <v-card width="100%">
        <v-card-title>Dados do registro</v-card-title>
        <v-card-text>
          <v-form>
            <div class="row">
              <div class="col-md-4 col-sm-1">
                <v-autocomplete
                label="Cliente"
                v-model="current.clientId"
                :search-input.sync="searchClient"
                :items="clients"
                item-text="name"
                item-value="id"
                outlined
                dense
                hide-details
              ></v-autocomplete>
              </div>
              <div class="col-md-4 col-sm-1">
                <v-autocomplete
                label="Plano"
                v-model="current.planId"
                :search-input.sync="searchPlan"
                :items="plans"
                item-text="name"
                item-value="id"
                outlined
                dense
                hide-details
              ></v-autocomplete>
              </div>
              <div class="col-md-4 col-sm-1">
                <v-select
                  label="Status"
                  v-model="current.status"
                  :items="status"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </div>
              <div class="col-md-3 col-sm-1">
                <v-text-field
                  label="Número"
                  v-model="current.number"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
              <div class="col-md-3 col-sm-1">
                <v-text-field
                  label="Senha"
                  v-model="current.password"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
              <div class="col-md-3 col-sm-1">
                <v-text-field
                  label="IP/Host"
                  v-model="current.ipaddr"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
              <div class="col-md-3 col-sm-1">
                <v-text-field
                  label="Porta"
                  v-model="current.ipport"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
              <div class="col-md-2 col-sm-1">
                <v-text-field
                  label="Código do País"
                  v-model="current.countryCode"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
              <div class="col-md-2 col-sm-1">
                <v-text-field
                  label="Código de Area"
                  v-model="current.areaCode"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
              <div class="col-md-2 col-sm-1">
                <v-text-field
                  label="CLI"
                  v-model="current.cli"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
              <div class="col-md-2 col-sm-1">
                <v-select
                  label="Discagem"
                  v-model="current.dialplan"
                  :items="dialplans"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </div>
              <div class="col-md-2 col-sm-1">
                <v-select
                  label="ACL"
                  v-model="current.acl"
                  :items="acls"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </div>
              <div class="col-md-2 col-sm-1">
                <v-text-field
                  label="Canais"
                  v-model="current.channels"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
              <div class="col-md-3 col-sm-1">
                <v-select
                  label="Bloqueio Voip"
                  v-model="current.blockVoip"
                  :items="blocks"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </div>
              <div class="col-md-3 col-sm-1">
                <v-select
                  label="Bloqueio Fixo"
                  v-model="current.blockLandline"
                  :items="blocks"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </div>
              <div class="col-md-3 col-sm-1">
                <v-select
                  label="Bloqueio Móvel"
                  v-model="current.blockMobile"
                  :items="blocks"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </div>
              <div class="col-md-3 col-sm-1">
                <v-select
                  label="Bloqueio Internacional"
                  v-model="current.blockInternational"
                  :items="blocks"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </div>
              <div class="col-md-3 col-sm-1">
                <v-text-field
                  label="Mensalidade"
                  v-model="current.monthly"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
              <div class="col-md-3 col-sm-1">
                <v-select
                  label="Tipo de Faturamento"
                  v-model="current.invoiceType"
                  :items="invoice"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </div>
              <div class="col-md-3 col-sm-1">
                <v-text-field
                  label="Data de Instalação"
                  v-model="current.setupFormatado"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
              <div class="col-md-3 col-sm-1">
                <v-text-field
                  label="Máximo de Registros"
                  v-model="current.maxregs"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </div>
              <div class="col-md-12 col-sm-1">
                <v-textarea
                  label="Observação"
                  v-model="current.obs"
                  outlined
                  dense
                  hide-details
                ></v-textarea>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
  
      <v-dialog v-model="dialog_loading" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Por favor aguarde
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
  
    </div>
  </template>
  
  <script>
  import api from "../../api/index.js";
  import router from '../../router/index.js';
  export default {
    data: () => ({
      current: null,
      status: [
        { value: 0, text: "Habilitado" },
        { value: 1, text: "Bloqueado administrador" },
        { value: 2, text: "Bloqueado cliente" },
        { value: 3, text: "Bloqueado pagamento" },
        { value: 4, text: "Cancelado" },
      ],
      invoice: [
        { value: 1, text: "Mensalidade + Consumo" },
        { value: 2, text: "Mensalidade apenas" },
        { value: 3, text: "Consumo apenas" }
      ],
      dialplans: [
        { value: "union-ss", text: "Padrão" }
      ],
      acls: [
        { value: "all", text: "Qualquer IP" },
        { value: "br", text: "Apenas IPs do Brasil" }
      ],
      blocks: [
        { value: true, text: "Habilitado" },
        { value: false, text: "Desabilitado" }
      ],
      clients: [],
      searchClient: null,
      plans: [],
      searchPlan: null,
      dialog_loading: false
    }),
    created: function () {
      this.load();
    },
    methods: {
      load: function () {
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
          .get("/sipline/0", {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function (response) {
            me.dialog_loading = false;
            const dataAtual = new Date();
            const ano = dataAtual.getFullYear();
            const mes = String(dataAtual.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
            const dia = String(dataAtual.getDate()).padStart(2, '0');
            const dataFormatada = `${dia}/${mes}/${ano}`;
            response.data.setupFormatado = dataFormatada;
            me.current = response.data;
          })
          .catch(function (error) {
            me.dialog_loading = false;
            alert("Falha ao recuperar registro!");
            console.log(error);
          });
      },
      save: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        var exp = this.current.setupFormatado.split('/');
        this.current.setup = exp[2]+'-'+exp[1]+'-'+exp[0];
        api
          .post("/sipline", this.current, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            me.dialog_loading = false;
            alert("Salvo com sucesso!");
            router.push({ path: "/sipline" });
          })
          .catch(function (error) {
            me.dialog_loading = false;
            alert("Falha ao salvar!");
            console.log(error);
          });
      },
      formatDate: function (date) {
        if (!date) return null;
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      }
    },
    computed: {
      computedSetup: function () {
        return this.formatDate(this.current.setup);
      }
    },
    watch: {
      searchClient: function(val) {
        var me = this;
        if(val.length!=3) return;
        var token = localStorage.getItem("token");
        api.get("/client/name/"+val, {headers: { Authorization: "Bearer " + token }})
        .then(function(response) {
          me.clients = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
      },
      searchPlan: function(val) {
        var me = this;
        if(val.length!=3) return;
        var token = localStorage.getItem("token");
        api.get("/plan/name/"+val, {headers: { Authorization: "Bearer " + token }})
        .then(function(response) {
          me.plans = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
      }
    }
  };
  </script>